export enum QuoteStatusStep {
  Comparison = 'Comparison',
  DontMatch = 'DontMatch',
}
